//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const ForgotPassword = createAsyncThunk(
  "ForgotPassword",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingForgotPassword(""));
      const response = await UsePortalApi(
        `Patient/ForgotPassword`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
      dispatch(gettingForgotPasswordSuccess(response)) 

      } else {
        dispatch(
          gettingForgotPasswordFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingForgotPasswordFailed(error));
    }
  }
);
const ForgotPasswordSlice = createSlice({
  name: "ForgotPassword",
  initialState: {
    ForgotPasswordData: null,
    isForgotPasswordLoading: false,
    isForgotPasswordError: false,
  },
  reducers: {
    gettingForgotPassword: (state, action) => {
      state.ForgotPasswordData = null;
      state.isForgotPasswordLoading = true;
      state.isForgotPasswordError = false;
    },
    gettingForgotPasswordSuccess: (state, action) => {
      state.ForgotPasswordData = action.payload;
      state.isForgotPasswordLoading = false;
      state.isForgotPasswordError = false;
    },
    gettingForgotPasswordFailed: (state, action) => {
      state.ForgotPasswordData = null;
      state.isForgotPasswordLoading = false;
      state.isForgotPasswordError = true;
    },
    gettingForgotPasswordClear: (state, action) => {
      state.ForgotPasswordData = null;
      state.isForgotPasswordLoading = false;
      state.isForgotPasswordError = false;
    },
  },
});
export const {
  gettingForgotPassword,
  gettingForgotPasswordSuccess,
  gettingForgotPasswordFailed,
  gettingForgotPasswordClear,
} = ForgotPasswordSlice.actions;
export default ForgotPasswordSlice.reducer;
